import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import { sanitizeText } from '../../utils/SanitizeText';

dayjs.locale('fr');

/*const ResourceHeader = (props) => {
    const name = props.resourceData?.Name ?? '';
    const role = props.resourceData?.Role ?? '';
    const initials = useMemo(() => name.split(' ').map(s => s[0]).join('').slice(0, 2).toUpperCase(), [name]);

    return (
        <div className="flex items-center gap-2 py-1">
            <div
                title={name}
                className="flex justify-center items-center rounded-full w-8 h-8 font-semibold text-white text-sm bg-orange-500"
            >
                {initials}
            </div>
            <div className="leading-tight">
                <div className="font-medium">{name}</div>
                <div className="opacity-70 text-[11px]">{role}</div>
            </div>
        </div>
    );
};*/

const ResourceHeader = (caName) => {
    const name = caName || '';
    const initials = name.split(' ').map(s => s[0]).join('').slice(0, 2).toUpperCase();

    return (
        <div
            title={name}
            className="flex justify-center items-center rounded-full w-10 h-10 font-semibold text-white text-sm bg-orange-500"
        >
            {initials}
        </div>
    );
};

function ListRDV({ lstRdv, loading }) {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);

    const isFakeRdv = (rdv) => rdv.Titre === "Aucun rendez-vous à venir";

    const itemsPerPage = 5;

    const handleRowClick = (uuid) => {
        if (uuid) navigate(`/declarations/${uuid}`);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = lstRdv.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(lstRdv.length / itemsPerPage);

    const goToNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const goToPrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    // console.log("ListRDV Rendered", lstRdv);

    return (
        <div className="mb-4">
            <div className="max-w-full overflow-x-auto">
                <div className="rounded-xl projects">
                    <table className="projects-table w-full min-w-[800px]">
                        <thead>
                            <tr className="*:text-sm">
                                <th>Titre</th>
                                <th className="text-center">Date de RDV</th>
                                <th>Charges Affaires</th>
                                <th>Site</th>
                                <th>Convocation</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                // Skeleton loading – 5 lignes simulées
                                Array.from({ length: itemsPerPage }).map((_, index) => (
                                    <tr key={`skeleton-${index}`} className="h-16 text-center">
                                        {Array.from({ length: 5 }).map((_, colIdx) => (
                                            <td key={colIdx}>
                                                <div className="bg-gray-700/30 mx-auto rounded-md w-3/4 h-4 animate-pulse"></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <>
                                    {currentItems.map((rdv, index) => {
                                        return (
                                            <tr key={index} className="hover:bg-gray-100 h-16 text-center cursor-pointer"
                                                onClick={() => !isFakeRdv(rdv) && handleRowClick(rdv.UUID_Declaration)}>

                                                <td>
                                                    <p>{rdv.Titre}</p>
                                                    <p>
                                                        {!isFakeRdv(rdv) &&
                                                            (rdv.DeclarationLibelle.length > 20
                                                                ? `${rdv.DeclarationLibelle.slice(0, 20)}…`
                                                                : rdv.DeclarationLibelle)
                                                        }
                                                    </p>
                                                </td>

                                                <td className="text-center">
                                                    {!isFakeRdv(rdv) ? (
                                                        <div className="flex justify-center items-center">
                                                            <p className="inline-block text-white">
                                                                <span className="block font-semibold text-[24px] text-white text-center leading-[0.7]">
                                                                    {dayjs(rdv.Date_Fix).format('DD')}
                                                                </span>
                                                                <span className="block text-[14px] text-gray-300">
                                                                    {dayjs(rdv.Date_Fix)
                                                                        .format("MMMM YYYY")
                                                                        .replace(/^\w/, (c) => c.toUpperCase())}
                                                                </span>
                                                            </p>
                                                            {rdv.Heure_Fix !== "Non Renseignée" && (
                                                                <>
                                                                    <span className="inline-block mx-2 text-gray-300 text-sm">à</span>
                                                                    <span className="inline-block text-white text-base">{rdv.Heure_Fix}</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div>-</div>
                                                    )}
                                                </td>

                                                <td className="member">
                                                    {!isFakeRdv(rdv) ? (
                                                        <>
                                                            <figure>
                                                                <img
                                                                    src={rdv.CA === "" || rdv.CA == null
                                                                        ? "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                                                        : ResourceHeader(rdv.CA)}
                                                                    alt={rdv.CA === "" || rdv.CA == null ? "Aucun Chargé d'affaires" : sanitizeText(rdv.CA)}
                                                                    className="rounded-full w-10 h-10 object-cover"
                                                                />
                                                            </figure>
                                                            <div className="member-info">
                                                                <p>{rdv.CA === "" || rdv.CA == null ? "Aucun" : rdv.CA}</p>
                                                                <p>Chargés Affaires</p>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div>-</div>
                                                    )}
                                                </td>

                                                <td>
                                                    {!isFakeRdv(rdv) ? <><p>{rdv.SiteNom}</p><p></p></> : "-"}
                                                </td>

                                                <td className="status">
                                                    {!isFakeRdv(rdv) ? (
                                                        <img
                                                            src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                                            alt="PDF"
                                                            className="mx-auto w-6 h-6"
                                                        />
                                                    ) : (
                                                        <div>-</div>
                                                    )}
                                                </td>
                                            </tr>

                                        );
                                    })}

                                    {Array.from({ length: itemsPerPage - currentItems.length }).map((_, index) => (
                                        <tr key={`empty-${index}`} className="opacity-0 h-16 text-center pointer-events-none select-none">
                                            <td><p>.</p></td>
                                            <td><p>.</p></td>
                                            <td><p>.</p></td>
                                            <td><p>.</p></td>
                                            <td><p>.</p></td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {totalPages > 1 && (
                <div className="flex justify-center items-center space-x-4 mt-6">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`w-10 h-10 rounded-full font-semibold text-sm border border-[#313D4E] transition duration-300
                    ${page === currentPage
                                    ? 'bg-orange-500 text-white shadow-md'
                                    : 'bg-[#273142] text-white hover:bg-[#313D4E]'}`}
                        >
                            {page}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ListRDV;
